import type { SiteSettings } from './types';

/** Default when App Settings director email is not set (see src/constants/legal.ts). */
export const DEFAULT_DIRECTOR_EMAIL = 'director@bethlehemhomeschool.group';

export function resolveDirectorEmail(settings: SiteSettings): string {
  const trimmed = settings.directorEmail?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : DEFAULT_DIRECTOR_EMAIL;
}

/** Maintenance page: optional override, else director email. */
export function resolveMaintenanceSupportEmail(settings: SiteSettings): string | undefined {
  const maintenance = settings.maintenanceSupportEmail?.trim();
  if (maintenance && maintenance.length > 0) {
    return maintenance;
  }
  const director = settings.directorEmail?.trim();
  if (director && director.length > 0) {
    return director;
  }
  return undefined;
}
